import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import rulerIcon from "@phosphor-icons/core/regular/ruler.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const leveler: Tool = {
    urlSlug: "leveler",
    configName: "teacher-tool-leveler",
    title: () => t`Leveler`,
    description: () => t`Adjust the complexity of a given text`,
    categories: [
        ToolCategories.Differentiate,
        ToolCategories.Create,
        ToolCategories.Support,
    ],
    icon: rulerIcon,
    color: color.fadedRed24,
    layout: Layout.Coeditor,
    reportingLabelId: "text-levler",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () => "",
            inputKind: "TEXT_BOX",
            label: () => t`Text title`,
            required: true,
            variableName: "TLTitle",
        },
        {
            description: () =>
                t`This works best for informational texts that are less than 1,500 words long. Literary texts are likely to lose much of the author's craft with re-leveling. `,
            inputKind: "TEXT_AREA",
            label: () => t`Original text`,
            maxCharacters: 26000,
            required: true,
            variableName: "TLText",
        },
        {
            description: () =>
                t`The original text will be approximately re-leveled to this grade level.`,
            inputKind: "SINGLE_SELECT",
            label: () => t`New reading level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
            ],
            variableName: "gradeLevel",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
